import axios from 'axios';
import { API_URL } from 'root/.env';

const PROTECTED_PREFIX = '/protected';

const http = axios.create({
  baseURL: `${API_URL}${PROTECTED_PREFIX}`,
});

http.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    config.headers.Authorization = `Bearer ${token}`;

    return config;
  },
  error => Promise.reject(error)
);

http.interceptors.response.use(
  response => response,
  error => new Promise(() => { throw error.response; })
);

export const apiCommon = axios.create({
  baseURL: `${API_URL}`,
});

export default http;
